import * as R from "ramda";
import { PARENTS_REF_PARAM, PARENTS_AND_SIBLINGS_REF_PARAM, CHILDREN_REF_PARAM, ALL_REF_PARAM, OVERVIEW_DETAIL_PARAM, PARTIAL_REF_DETAIL_PARAM } from "./constants/params.mjs";
const getReferences = (args) => {
  if (R.prop("withParents", args)) {
    return { references: PARENTS_REF_PARAM };
  }
  if (R.prop("withParentsAndSiblings", args)) {
    return { references: PARENTS_AND_SIBLINGS_REF_PARAM };
  }
  if (R.prop("withChildren", args)) {
    return { references: CHILDREN_REF_PARAM };
  }
  if (R.propOr(true, "withReferences", args)) {
    return { references: ALL_REF_PARAM };
  }
  return {};
};
const getDetails = (args) => {
  if (R.prop("overview", args)) {
    return { detail: OVERVIEW_DETAIL_PARAM };
  }
  if (R.path(["datasource", "supportsReferencePartial"], args) && R.prop("withPartialReferences", args)) {
    return { detail: PARTIAL_REF_DETAIL_PARAM };
  }
  return {};
};
const getStructureParams = (args) => {
  const customParams = R.propOr({}, "params", args);
  const defaultParams = R.converge(R.mergeRight, [getReferences, getDetails])(
    args
  );
  return R.mergeLeft(customParams, defaultParams);
};
export {
  getStructureParams
};
